import { useMemo } from 'react';

import { getExponeaItemProps } from 'Helpers/item';

export const useItemProps = item => {
    const itemInfo = useMemo(() => getExponeaItemProps(item), [item]);

    return itemInfo;
};
